import React from 'react';
import { useCollapsibleState } from '../hooks/useCollapsibleState';

interface FlowMetadataProps {
  flow: any;
  orgData?: any;
}

const FlowMetadata: React.FC<FlowMetadataProps> = ({ flow, orgData }) => {
  const [isExpanded, setIsExpanded] = useCollapsibleState('flowDetails', true);
  
  // Check for required data
  if (!flow) {
    return null;
  }
  
  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
      <div className="px-4 py-5 sm:px-6 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="flex items-center justify-between">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Flow Details</h3>
          <svg
            className={`w-5 h-5 text-gray-500 transform transition-transform ${isExpanded ? '' : 'rotate-180'}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      
      {isExpanded && (
        <div className="border-t border-gray-200">
          <div className="bg-gray-50 px-4 py-4 sm:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Last Modified Date */}
              <div>
                <dt className="text-sm font-medium text-gray-500">Last Modified</dt>
                <dd className="mt-1 text-sm text-gray-900">
                  {flow.last_modified_date ? 
                    new Date(flow.last_modified_date).toLocaleString() : 
                    flow.metadata?.LastModifiedDate ? 
                      new Date(flow.metadata?.LastModifiedDate).toLocaleString() : 
                      'Unknown'}
                </dd>
              </div>
              
              {/* Last Modified By */}
              <div>
                <dt className="text-sm font-medium text-gray-500">Modified By</dt>
                <dd className="mt-1 text-sm text-gray-900">
                  {flow.metadata?.LastModifiedBy?.Name || 
                   flow.metadata?.LastModifiedBy || 
                   flow.last_modified_by || 
                   'Unknown'}
                </dd>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlowMetadata;